import { API } from '../api'
import { PickupAddressPointDetailsResponse } from './interface'

export const getPickupAddressPointDetails = async (
  idPostoDeColeta: string
): Promise<PickupAddressPointDetailsResponse | null> => {
  try {
    const response = await API.get<PickupAddressPointDetailsResponse>(
      '/logistica/postos-de-coleta/obter-detalhes',
      {
        idPostoDeColeta
      }
    )

    return response
  } catch (error) {
    console.error('Erro ao buscar detalhes do posto de coleta:', error)
    return null
  }
}
